$(function() {
    var current_year = new Date().getFullYear();
    $('.sti-date-picker').datepicker({
        pickTime: false,
        autoclose: true,
        startView: 'decade',
        defaultViewDate: { year: current_year}
    });
});
